import { cn } from '@latitude/token-utils';
import * as LabelPrimitive from '@radix-ui/react-label';
import type { ComponentRef, Ref } from 'react';
import type { RadioGroupLabelProps } from 'types';
import { radioButtonLabelClasses } from 'variants';

const RadioGroupItemLabel = ({
  className,
  ref,
  ...props
}: RadioGroupLabelProps & {
  ref?: Ref<ComponentRef<typeof LabelPrimitive.Root>>;
}) => {
  return (
    <LabelPrimitive.Root
      {...props}
      ref={ref}
      className={cn(radioButtonLabelClasses, className)}
    />
  );
};

RadioGroupItemLabel.displayName = 'RadioGroupItemLabel';

export default RadioGroupItemLabel;
